import { validatePhone } from "./formValidators.js";

export const getPaymentContactValue = (prefill = {}) =>
  String(prefill.phone || prefill.contact || "").trim();

export const getUserPaymentContact = (user, userProfile) =>
  getPaymentContactValue({
    phone:
      userProfile?.phone ||
      user?.phone ||
      user?.user_metadata?.phone ||
      user?.app_metadata?.phone ||
      "",
  });

const toDigits = (value) => String(value || "").replace(/\D/g, "");

const getIndianMobileDigits = (value) => {
  const digits = toDigits(value);
  if (digits.length === 12 && digits.startsWith("91")) return digits.slice(2);
  if (digits.length === 11 && digits.startsWith("0")) return digits.slice(1);
  return digits;
};

const isLowQualityNumber = (digits) => {
  if (!digits) return true;
  if (new Set(digits).size < 4) return true;
  return ["1234567890", "9876543210"].includes(digits);
};

export const validatePaymentContact = (
  value,
  { currency = "INR", required = true } = {},
) => {
  const trimmed = String(value || "").trim();
  if (!trimmed) {
    return required ? "Payment contact is required." : null;
  }

  const baseError = validatePhone(trimmed, "Payment contact", { required });
  if (baseError) return baseError;

  if (currency === "INR") {
    const mobileDigits = getIndianMobileDigits(trimmed);
    if (!/^[6-9]\d{9}$/.test(mobileDigits) || isLowQualityNumber(mobileDigits)) {
      return "Payment contact must be a valid 10-digit Indian mobile number.";
    }
    return null;
  }

  const digits = toDigits(trimmed);
  if (digits.length > 15 || isLowQualityNumber(digits)) {
    return "Payment contact must be a valid phone number.";
  }

  return null;
};
